import { createDefaultFormatters, createStandardConfig } from './utils'

/**
 * Canada Address Configuration
 */
export const CA_CONFIG = createStandardConfig({
  countryCode: 'CA',
  countryName: 'Canada',
  requiresStreetNumber: true,
  formatters: createDefaultFormatters(),
  fieldOverrides: {
    city: {
      googleTypes: [
        'locality',
        'sublocality_level_1',
        'administrative_area_level_3',
        'postal_town'
      ]
    },
    stateOrProvince: {
      labelKey: 'address-config.province',
      errorKey: 'address-config.province-required'
    },
    postalCode: {
      labelKey: 'address-config.postal-code',
      errorKey: 'address-config.postal-code-required'
    }
  }
})
